import React, { useEffect, useState } from "react";
import { Star, Quotes } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function ReviewsWall({ fallback }) {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/public/reviews/wall")
      .then((r) => { if (active) setReviews(r.data.reviews || []); })
      .catch(() => { if (active) setReviews([]); });
    return () => { active = false; };
  }, []);

  // While loading, render nothing to avoid layout shift.
  if (reviews === null) return null;
  // Not enough genuine reviews yet — show the fallback ("Built for…") section.
  if (reviews.length < 3) return fallback || null;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="reviews-wall">
      <div className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0055FF]">Real customer reviews</p>
        <h2 className="mt-2 font-display text-4xl font-black tracking-tighter text-slate-900">What people are saying</h2>
        <p className="mt-3 text-slate-600 max-w-2xl mx-auto">Genuine, approved reviews collected by businesses using Local CiteHub.</p>
      </div>
      <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
        {reviews.map((r, i) => (
          <figure key={i} data-testid={`wall-review-${i}`}
            className="mb-6 break-inside-avoid rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex items-center justify-between">
              <div className="flex gap-0.5 text-amber-400">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} weight={n <= r.rating ? "fill" : "regular"} size={16} className={n <= r.rating ? "text-amber-400" : "text-slate-200"} />
                ))}
              </div>
              <Quotes weight="fill" size={22} className="text-slate-100" />
            </div>
            <blockquote className="mt-3 text-slate-700 leading-relaxed">“{r.comment}”</blockquote>
            <figcaption className="mt-4 pt-4 border-t border-slate-100">
              <p className="font-display font-bold text-slate-900">{r.reviewer_name}</p>
              <p className="text-sm text-slate-500">
                {r.business_name}{(r.city || r.state) ? ` · ${[r.city, r.state].filter(Boolean).join(", ")}` : ""}
              </p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
